/**
* Do not edit directly
* Generated on Fri, 15 Aug 2025 16:47:00 GMT
*/

module.exports = {
  "brand-background-image": "radial-gradient(88.02% 32.04% at 50% 7.61%, #FFFFFF 0%, #E9E9EC 100%)",
  "brand-secondary-50": "#dfedf5",
  "brand-secondary-100": "#a6d4ef",
  "brand-secondary-200": "#70bde9",
  "brand-secondary-300": "#3fa6e2",
  "brand-secondary-400": "#2998e2",
  "brand-secondary-500": "#198de0",
  "brand-secondary-600": "#0066c5",
  "brand-secondary-700": "#004f9e",
  "brand-secondary-800": "#00346b",
  "brand-secondary-900": "#001e40",
  "brand-success-50": "#dff5e4",
  "brand-success-100": "#a2deb0",
  "brand-success-200": "#6dc682",
  "brand-success-300": "#41cc64",
  "brand-success-400": "#2fce57",
  "brand-success-500": "#16c946",
  "brand-success-600": "#0ebb3c",
  "brand-success-700": "#08982e",
  "brand-success-800": "#04681f",
  "brand-success-900": "#024011",
  "brand-warning-50": "#f5e9df",
  "brand-warning-100": "#f6d4b9",
  "brand-warning-200": "#f6c094",
  "brand-warning-300": "#f69d54",
  "brand-warning-400": "#f2883d",
  "brand-warning-500": "#eb772a",
  "brand-warning-600": "#e1671c",
  "brand-warning-700": "#a43f09",
  "brand-warning-800": "#6e2704",
  "brand-warning-900": "#401502",
  "brand-danger-50": "#fae6e7",
  "brand-danger-100": "#f0b5b8",
  "brand-danger-200": "#f19093",
  "brand-danger-300": "#f16e74",
  "brand-danger-400": "#f05058",
  "brand-danger-500": "#ec3a40",
  "brand-danger-600": "#c91016",
  "brand-danger-700": "#a1090c",
  "brand-danger-800": "#6c0406",
  "brand-danger-900": "#400203",
  "brand-primary-accent-50": "#e5dff5",
  "brand-primary-accent-100": "#c9b9f5",
  "brand-primary-accent-200": "#ad93f5",
  "brand-primary-accent-300": "#9471f4",
  "brand-primary-accent-400": "#6b3bef",
  "brand-primary-accent-500": "#5b27e9",
  "brand-primary-accent-600": "#400dcc",
  "brand-primary-accent-700": "#2f05a3",
  "brand-primary-accent-800": "#1e016d",
  "brand-primary-accent-900": "#110040",
  "brand-secondary-accent-50": "#faf6e3",
  "brand-secondary-accent-100": "#f6e7ab",
  "brand-secondary-accent-200": "#f9df7f",
  "brand-secondary-accent-300": "#fdd142",
  "brand-secondary-accent-400": "#f5b937",
  "brand-secondary-accent-500": "#eda130",
  "brand-secondary-accent-600": "#df8d29",
  "brand-secondary-accent-700": "#99541b",
  "brand-secondary-accent-800": "#603412",
  "brand-secondary-accent-900": "#351e0c",
  "brand-neutral-warm-50": "#f7f0f4",
  "brand-neutral-warm-100": "#e0d8dc",
  "brand-neutral-warm-200": "#c9c0c5",
  "brand-neutral-warm-300": "#b2a9ae",
  "brand-neutral-warm-400": "#9b9297",
  "brand-neutral-warm-500": "#6e666b",
  "brand-neutral-warm-600": "#585155",
  "brand-neutral-warm-700": "#413c3f",
  "brand-neutral-warm-800": "#2b2729",
  "brand-neutral-warm-900": "#141314",
  "brand-neutral-cool-50": "#e3e9f0",
  "brand-neutral-cool-100": "#d7dee5",
  "brand-neutral-cool-200": "#cbd2db",
  "brand-neutral-cool-300": "#b4bcc5",
  "brand-neutral-cool-400": "#9ea5af",
  "brand-neutral-cool-500": "#888f99",
  "brand-neutral-cool-600": "#5f656d",
  "brand-neutral-cool-700": "#383b40",
  "brand-neutral-cool-800": "#25272a",
  "brand-neutral-cool-900": "#121314",
  "brand-surface-elevation-50": "#ffffff",
  "brand-surface-elevation-100": "#ffffff",
  "brand-surface-elevation-200": "#ffffff",
  "brand-surface-elevation-300": "#ffffff",
  "brand-surface-elevation-400": "#ffffff",
  "brand-surface-elevation-500": "#ffffff",
  "brand-surface-elevation-600": "#ffffff",
  "brand-surface-elevation-700": "#ffffff",
  "brand-surface-elevation-800": "#ffffff",
  "brand-surface-elevation-900": "#ffffff",
  "brand-surface-layer-50": "#f7f7f8",
  "brand-surface-layer-100": "#f4f4f5",
  "brand-surface-layer-200": "#f2f2f3",
  "brand-surface-layer-300": "#efeff0",
  "brand-surface-layer-400": "#ececee",
  "brand-surface-layer-500": "#eaeaec",
  "brand-surface-layer-600": "#e7e7e9",
  "brand-surface-layer-700": "#e4e4e7",
  "brand-surface-layer-800": "#e2e2e4",
  "brand-surface-layer-900": "#dfdfe2",
  "brand-primary-border-50": "rgba(17, 18, 19, 0.05)",
  "brand-primary-border-100": "rgba(17, 18, 19, 0.1)",
  "brand-primary-border-200": "rgba(17, 18, 19, 0.2)",
  "brand-primary-border-300": "rgba(17, 18, 19, 0.3)",
  "brand-primary-border-400": "rgba(17, 18, 19, 0.4)",
  "brand-primary-border-500": "rgba(17, 18, 19, 0.5)",
  "brand-primary-border-600": "rgba(17, 18, 19, 0.6)",
  "brand-primary-border-700": "rgba(17, 18, 19, 0.7)",
  "brand-primary-border-800": "rgba(17, 18, 19, 0.8)",
  "brand-primary-border-900": "rgba(17, 18, 19, 0.9)",
  "brand-market-temp-cold": "#0066c5",
  "brand-market-temp-cool": "#70bde9",
  "brand-market-temp-neutral": "#b4bcc5",
  "brand-market-temp-warm": "#fdd142",
  "brand-market-temp-hot": "#f2883d",
  "brand-market-temp-font-cold": "#0e5fb6",
  "brand-market-temp-font-cool": "#053d7d",
  "brand-market-temp-font-neutral": "#1b1d20",
  "brand-market-temp-font-warm": "#603412",
  "brand-market-temp-font-hot": "#b64913",
  "brand-primary-50": "#f5dfe8",
  "brand-primary-100": "#efcedc",
  "brand-primary-200": "#eda8c6",
  "brand-primary-300": "#e369a0",
  "brand-primary-400": "#dc4c8a",
  "brand-primary-500": "#d92573",
  "brand-primary-600": "#d21869",
  "brand-primary-700": "#9c0547",
  "brand-primary-800": "#6a012f",
  "brand-primary-900": "#40001c",
  "brand-hb-black": "#000000",
  "brand-hb-white": "#ffffff",
  "brand-hb-homebot": "#f85099",
  "brand-hb-homebot-fill": "#322c3a",
  "brand-hb-core-logic": "#e53e24",
  "brand-hb-realty-trac": "#ab24e5",
  "brand-hb-zillow": "#0076e4",
  "brand-hb-shadow-neutral-10": "rgba(4,4,6,.1)",
  "brand-hb-shadow-neutral-15": "rgba(4,4,6,.15)",
  "brand-hb-shadow-neutral-20": "rgba(4,4,6,.2)",
  "brand-hb-shadow-neutral-30": "rgba(4,4,6,.3)",
  "brand-hb-shadow-neutral-05": "rgba(4,4,6,.05)",
  "brand-hb-shadow-neutral-06": "rgba(4,4,6,.06)",
  "brand-hb-shadow-neutral-07": "rgba(4,4,6,.07)",
  "brand-hb-shadow-neutral-08": "rgba(4,4,6,.08)"
}